import { COMMON_TEXT } from '@/helpers/common-text';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import { FieldArray, Form, Formik, getIn } from 'formik';
import { cloneDeep, isEmpty } from 'lodash';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import React, { Component, Fragment } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/CustomComponent/LoadingSpinner';
import { getConfigurationUrlWithParam } from 'src/helpers/utility';
import * as Yup from 'yup';
import {
  fetchArubaBuildings,
  fetchBranchList,
  fetchMerakiNetworks,
  fetchOrganizationList,
} from './query-request';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import Toaster from 'src/components/CustomComponent/Toaster';
import SaveButton from 'src/components/CustomComponent/SaveButton/SaveButton';

Yup.addMethod(Yup.array, 'merakiArubaUnique', function (field, message) {
  return this.test('merakiArubaUnique', message, function (array) {
    // Flatten all merakiArubaList items into a single list
    const merakiArubaListFlat = array.flatMap(item => item.merakiArubaList);
    const seen = new Set();
    let duplicateValue = null;

    for (let i = 0; i < merakiArubaListFlat.length; i++) {
      const value =
        typeof merakiArubaListFlat[i][field] === 'string'
          ? merakiArubaListFlat[i][field].toLowerCase()
          : merakiArubaListFlat[i][field];
      if (seen.has(value)) {
        duplicateValue = value;
        break;
      }
      if (value) seen.add(value);
    }

    if (!duplicateValue) {
      return true;
    }

    const branchIndex = array.findIndex(branch =>
      branch.merakiArubaList.some(
        device => device[field]?.toLowerCase() === duplicateValue
      )
    );

    const deviceIndex = array[branchIndex].merakiArubaList.findIndex(
      device => device[field]?.toLowerCase() === duplicateValue
    );

    return this.createError({
      path: `${this.path}[${branchIndex}].merakiArubaList[${deviceIndex}].${field}`,
      message,
    });
  });
});

Yup.addMethod(Yup.array, 'validMerakiArubaList', function (message) {
  return this.test('validMerakiArubaList', message, function (array) {
    if (array.length >= 2) {
      // find index of item that has value is empty
      const deviceIndex = array.findIndex(branch =>
        array.some(item => !item.value)
      );
      if (deviceIndex >= 0) {
        return this.createError({
          path: `${this.path}.[${deviceIndex}].value`,
          message,
        });
      }
    }
    return true;
  });
});

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class LocationSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      groupedOptions: [{ label: 'なし', value: '' }],
      branchMerakiArubaList: [],
      formKey: Date.now(),
    };
    this.toastRef = React.createRef();
    this.locationSettingFormContainerRef = React.createRef();
    this.cloneBranchMerakiArubaList = [];
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.getData();
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };

  getArubaBuildingListByTenantId = async ({ tenantId }) => {
    const buildings = await fetchArubaBuildings({ tenantId });
    return buildings || [];
  };

  getMerakiNetworkListByTenantId = async ({ tenantId }) => {
    let organizationRes = await fetchOrganizationList({ tenantId });
    organizationRes = organizationRes || [];
    const orgIdentiferList = organizationRes.map(item => item.org_identifer);
    let merakiNetworkList = [];
    if (orgIdentiferList && orgIdentiferList.length > 0) {
      let networkRes = await fetchMerakiNetworks({ orgIdentiferList });

      merakiNetworkList = networkRes || [];
    }
    return { merakiNetworkList };
  };

  getBranchListByTenantId = async ({ tenantId }) => {
    const branchesRes = await fetchBranchList({ tenantId });
    return branchesRes || [];
  };

  getData = async () => {
    const { tenant } = this.state;
    this.setState({ isLoading: true });
    const branchList = await this.getBranchListByTenantId({ tenantId: tenant });
    const branchMerakiArubaList = branchList.map(item => ({
      tenantId: item.tenant_id,
      branchId: item.branch_id,
      branchName: item.branch_name,
      branchOrder: item.branch_order,
      merakiNetworkList: [],
      arubaBuildingList: [],
      merakiArubaList: [],
    }));

    const arubaBuildingList = await this.getArubaBuildingListByTenantId({
      tenantId: tenant,
    });

    const { merakiNetworkList } = await this.getMerakiNetworkListByTenantId({
      tenantId: tenant,
    });

    for (let branchMerakiArubaDeviceItem of branchMerakiArubaList) {
      let { branchId } = branchMerakiArubaDeviceItem;
      const arubaBuildingListByBranchId = arubaBuildingList.filter(
        item => item.branch_id === branchId
      );
      if (
        arubaBuildingListByBranchId &&
        arubaBuildingListByBranchId.length > 0
      ) {
        const arubaBuildingList = arubaBuildingListByBranchId.map(item => ({
          buildingId: item.building_id,
          buildingName: item.building_name,
          branchId: branchId,
        }));
        branchMerakiArubaDeviceItem.arubaBuildingList =
          cloneDeep(arubaBuildingList);
      } else {
        branchMerakiArubaDeviceItem.arubaBuildingList = null;
      }

      const merakiNetworkListByBranchId = merakiNetworkList.filter(
        item => item.branch_id === branchId
      );
      if (
        merakiNetworkListByBranchId &&
        merakiNetworkListByBranchId.length > 0
      ) {
        const merakiNetworkList = merakiNetworkListByBranchId.map(item => ({
          networkId: item.network_identifer,
          networkName: item.network_name,
          branchId: branchId,
        }));
        branchMerakiArubaDeviceItem.merakiNetworkList =
          cloneDeep(merakiNetworkList);
      } else {
        branchMerakiArubaDeviceItem.merakiNetworkList = null;
      }

      let merakiArubaList = [
        ...(branchMerakiArubaDeviceItem.merakiNetworkList?.map(network => {
          return {
            value: network.networkId,
          };
        }) || []),
        ...(branchMerakiArubaDeviceItem.arubaBuildingList?.map(building => {
          return {
            value: building.buildingId,
          };
        }) || []),
      ];

      if (merakiArubaList.length === 0) {
        merakiArubaList.push({
          value: '',
        });
      }
      branchMerakiArubaDeviceItem.merakiArubaList = cloneDeep(merakiArubaList);
    }

    const arubaBuildingOptions = arubaBuildingList.map(item => ({
      label: item.building_name,
      value: item.building_id,
    }));

    const merakiNetworkOptions = merakiNetworkList.map(item => ({
      label: item.network_name,
      value: item.network_identifer,
    }));

    let groupedOptions = [
      {
        label: '',
        value: '',
        items: [
          {
            label: 'なし',
            value: '',
          },
        ],
      },
      {
        label: 'Merakiネットワーク',
        value: 'meraki',
        items: cloneDeep(merakiNetworkOptions),
      },
      {
        label: 'Arubaサイト',
        value: 'aruba',
        items: cloneDeep(arubaBuildingOptions),
      },
    ];

    this.cloneBranchMerakiArubaList = cloneDeep(branchMerakiArubaList);

    this.setState({
      branchMerakiArubaList: cloneDeep(branchMerakiArubaList),
      groupedOptions: cloneDeep(groupedOptions),
      isLoading: false,
      isUpdating: false,
      formKey: Date.now(), // Add a key to force form re-initialization
    });
  };

  findItemChanges({ updatedArray, originalArray }) {
    // Helper function to check if merakiNetworkList has changed
    const isMerakiListChanged = (list1, list2) => {
      if (list1.length !== list2.length) return true;
      for (let i = 0; i < list1.length; i++) {
        if (
          list1[i].value !== list2[i].value ||
          list1[i].label !== list2[i].label
        ) {
          return true;
        }
      }
      return false;
    };

    // Finding newItems
    const newItems = updatedArray.filter(item => item.branchId === null);

    // Finding deletedItems
    const deletedItems = originalArray.filter(originalItem => {
      return !updatedArray.some(
        uItem => uItem.branchId === originalItem.branchId
      );
    });

    // Finding updatedItems
    const updatedItems = updatedArray.filter(uItem => {
      // If the item is in the deleted list, it can't be in the updated list
      if (deletedItems.some(dItem => dItem.branchId === uItem.branchId))
        return false;

      const originalItem = originalArray.find(
        oItem => oItem.branchId === uItem.branchId
      );
      if (!originalItem) return false; // if not found in originalArray, it can't be updated

      // Check for branchName or merakiNetworkList changes
      return (
        originalItem.branchName !== uItem.branchName ||
        originalItem.branchOrder !== uItem.branchOrder ||
        isMerakiListChanged(originalItem.merakiArubaList, uItem.merakiArubaList)
      );
    });

    return {
      newItems,
      deletedItems,
      updatedItems,
    };
  }

  getNetworkBuildingList = item => {
    let { merakiArubaList } = item;
    merakiArubaList = merakiArubaList.filter(item => item.value !== '');

    const { groupedOptions } = this.state;
    const merakiElements = [];
    const arubaElements = [];

    merakiArubaList.forEach(element => {
      const foundGroup = groupedOptions.find(group =>
        group.items.some(item => item.value === element.value)
      );

      if (foundGroup?.value === 'meraki') {
        merakiElements.push(element.value);
      } else if (foundGroup?.value === 'aruba') {
        arubaElements.push(element.value);
      }
    });

    return {
      network_identifers: merakiElements,
      buildings: arubaElements,
    };
  };

  getUpdateDataPayload = ({ newItems, deletedItems, updatedItems }) => {
    let payload = {
      values: [],
    };
    for (let item of newItems) {
      payload.values.push({
        id: null,
        name: item.branchName,
        order: item.branchOrder,
        ...this.getNetworkBuildingList(item),
      });
    }

    for (let item of deletedItems) {
      payload.values.push({
        id: item.branchId,
        network_identifers: null,
      });
    }

    for (let item of updatedItems) {
      payload.values.push({
        id: item.branchId,
        name: item.branchName,
        order: item.branchOrder,
        ...this.getNetworkBuildingList(item),
      });
    }
    return payload;
  };

  updateBranchInfo = async ({ updatePayLoad }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsBranches({
        apiPostWorkflowRequest: {
          ...updatePayLoad,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('UPDATE SETTING ERROR');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('UPDATE SETTING ERROR', error);
    }
    return { isSuccess: false };
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    const { isSuccess } = await this.updateBranchInfo({
      updatePayLoad,
    });

    if (isSuccess) {
      // Refresh the data to show updated information instantly
      await this.getData();
      Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
    } else {
      this.setState({ isUpdating: false }, () => {
        Toaster.error(COMMON_TEXT.SAVE_FAILED);
      });
    }
  };

  renderSettingContent() {
    const { isLoading, isUpdating, branchMerakiArubaList, tenant } = this.state;

    const addNewBranch = ({ arrayHelpers, branches }) => {
      arrayHelpers.push({
        tenantId: tenant,
        branchId: null,
        branchName: '',
        branchOrder: branches.length + 1,
        merakiArubaList: [],
      });
      
      // Scroll to bottom after adding new branch
      setTimeout(() => {
        if (this.locationSettingFormContainerRef.current) {
          this.locationSettingFormContainerRef.current.scrollTop = this.locationSettingFormContainerRef.current.scrollHeight;
        }
      }, 100);
    };

    const addNewMerakiAruba = ({ arrayHelpers, index }) => {
      arrayHelpers.push({
        value: '',
      });
    };

    const deleteAccepted = ({ arrayHelpers, index }) => {
      arrayHelpers.remove(index);
      // delete index
      const branchList = arrayHelpers.form.values.branches;
      branchList.splice(index, 1);
      // rearrange branchOrder
      branchList.map((branch, branchIndex) => {
        branch.branchOrder = branchIndex + 1;
        return '';
      });
    };

    const merakiDeleteAccepted = ({ arrayHelpers, index, dataList }) => {
      if (dataList.length === 1) {
        arrayHelpers.replace(index, {
          value: '',
        });
      } else {
        arrayHelpers.remove(index);
      }
    };

    const deleteButtonOnClicked = (e, { arrayHelpers, item, index }) => {
      const { branchId } = item;

      if (branchId > 0) {
        confirmDialog({
          message: COMMON_TEXT.DELETE_CONFIRM_MESSAGE,
          header: COMMON_TEXT.DELETE_CONFIRMATION_HEADER,
          icon: '',
          accept: () => deleteAccepted({ arrayHelpers, index }),
          reject: () => { },
          acceptClassName: 'p-button-danger',
          rejectClassName: 'p-button-secondary p-button-text',
          appendTo: 'self',
        });
      } else {
        deleteAccepted({ arrayHelpers, index });
      }
    };

    const deleteMerakiButtonOnClicked = (
      e,
      { arrayHelpers, item, index, dataList }
    ) => {
      const { value } = item;
      if (!isEmpty(value)) {
        confirmDialog({
          message: COMMON_TEXT.DELETE_CONFIRM_MESSAGE,
          header: COMMON_TEXT.DELETE_CONFIRMATION_HEADER,
          icon: '',
          accept: () =>
            merakiDeleteAccepted({
              arrayHelpers,
              index,
              dataList,
            }),
          reject: () => { },
          acceptClassName: 'p-button-danger',
          rejectClassName: 'p-button-secondary p-button-text',
          appendTo: 'self',
        });
      } else {
        merakiDeleteAccepted({ arrayHelpers, index, dataList });
      }
    };

    const handleSubmit = (values, { setSubmitting, errors }) => {
      if (!errors) {
        const { newItems, deletedItems, updatedItems } = this.findItemChanges({
          updatedArray: values.branches,
          originalArray: this.cloneBranchMerakiArubaList,
        });
        const updatePayLoad = this.getUpdateDataPayload({
          newItems,
          deletedItems,
          updatedItems,
        });
        const { values: payloadValues } = updatePayLoad;
        if (payloadValues.length === 0) {
          return;
        }
        this.updateData({ updatePayLoad });
      } else {
      }
    };

    const isFormFieldInvalid = ({ name, touched, errors }) => {
      const error = getIn(errors, name);
      const touch = getIn(touched, name);
      return touch && error ? 'p-invalid' : '';
    };

    const getFormErrorMessage = ({ name, touched, errors }) => {
      return isFormFieldInvalid({ name, touched, errors }) ? (
        <span className="validation-error-message">{getIn(errors, name)}</span>
      ) : (
        <></>
      );
    };

    const branchSchema = Yup.object().shape({
      branchName: Yup.string().required('Branch Name is required'),
      merakiArubaList: Yup.array().validMerakiArubaList(
        'invalid merakiArubaList'
      ),
    });

    const formSchema = Yup.object().shape({
      branches: Yup.array()
        .merakiArubaUnique('value', 'ネットワークID/ビルディングIDが重複しています')
        .of(branchSchema)
        .required('Branches are required'),
    });

    const onDragEnd = (result, { arrayHelpers, branches }) => {
      // dropped outside the list
      if (!result.destination) {
        return;
      }
      const sourceItem = branches[result.source.index];
      const destinationItem = branches[result.destination.index];
      sourceItem.branchOrder = result.destination.index + 1;
      destinationItem.branchOrder = result.source.index + 1;
      arrayHelpers.replace(result.source.index, destinationItem);
      arrayHelpers.replace(result.destination.index, sourceItem);
    };

    const renderMerakiArubaItem = ({
      index,
      merakiArubaIndex,
      merakiArubaInfo,
      setFieldValue,
      touched,
      errors,
      merakiArubaListHelpers,
      branchInfo,
    }) => {
      const { groupedOptions } = this.state;

      const handleChange = e => {
        const selectedValue = e.value;
        setFieldValue(
          `branches[${index}].merakiArubaList[${merakiArubaIndex}].value`,
          selectedValue
        );
      };

      // Custom item template function to add class names based on group type
      const customItemTemplate = (option) => {
        if (!option) return null;

        // Find which group this option belongs to
        const parentGroup = groupedOptions.find(group =>
          group.items && group.items.some(item => item.value === option.value)
        );

        let itemClass = 'dropdown-item';

        if (parentGroup?.value === 'meraki') {
          itemClass += ' dropdown-item-meraki';
        } else if (parentGroup?.value === 'aruba') {
          itemClass += ' dropdown-item-aruba';
        } else {
          itemClass += ' dropdown-item-empty';
        }

        return (
          <div className={itemClass}>
            <span className="dropdown-item-label">{option.label}</span>
          </div>
        );
      };

      // Custom group template function to add class names based on group type
      const customGroupTemplate = (option) => {
        var labelClass = 'dropdown-group-label';
        if (option.label === '') {
          labelClass = 'dropdown-group-label-empty';
        }

        return (
          <div className={`branch-dropdown-group`}>
            <span className={labelClass}>{option.label}</span>
          </div>
        );
      };

      return (
        <Fragment key={`meraki-device-item-${merakiArubaIndex}`}>
          <div className="meraki-field-container">
            <div className="input-row">
              <div className="figma-dropdown">
                <Dropdown
                  id={`branches[${index}].merakiArubaList[${merakiArubaIndex}].value`}
                  value={merakiArubaInfo.value}
                  options={groupedOptions}
                  optionGroupLabel="label"
                  optionGroupChildren="items"
                  itemTemplate={customItemTemplate}
                  optionGroupTemplate={customGroupTemplate}
                  onChange={handleChange}
                  style={{
                    width: '320px',
                  }}
                  className={`${isFormFieldInvalid({
                    name: `branches[${index}].merakiArubaList[${merakiArubaIndex}].value`,
                    touched,
                    errors,
                  })}`}
                />
              </div>
              <Button
                type="button"
                text
                severity="danger"
                className="icon-only-delete-button"
                onClick={e =>
                  deleteMerakiButtonOnClicked(e, {
                    arrayHelpers: merakiArubaListHelpers,
                    item: merakiArubaInfo,
                    dataList: branchInfo.merakiArubaList,
                    index: merakiArubaIndex,
                  })
                }
              >
                <span className="delete-icon">
                  <img src="assets/img/trash-icon.svg" alt="Delete" />
                </span>
              </Button>
            </div>
            {getFormErrorMessage({
              name: `branches[${index}].merakiArubaList[${merakiArubaIndex}].value`,
              touched,
              errors,
            })}
          </div>
        </Fragment>
      );
    };

    const renderMainContent = ({
      values,
      arrayHelpers,
      handleChange,
      setFieldValue,
      touched,
      errors,
    }) => {
      return (
        <div className="main-content">
          <DragDropContext
            onDragEnd={e =>
              onDragEnd(e, {
                arrayHelpers,
                branches: values.branches,
              })
            }
          >
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {values.branches
                    .sort((a, b) => a.branchOrder - b.branchOrder)
                    .map((branchInfo, index) => (
                      <Draggable
                        key={branchInfo.branchOrder}
                        draggableId={`draggable-${branchInfo.branchOrder}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <>
                            <div
                              className={`main-row-container border-bottom ${snapshot.isDragging ? `is-dragging` : ''
                                }`}
                              key={index}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div className="input-text-field-container index-field">
                                <img src="assets/img/drag-handle-icon.svg" alt="Drag Handle" />
                              </div>
                              <div className="input-text-field-container name-field">
                                <div className="input-row">
                                  <InputText
                                    id={`branches[${index}].branchName`}
                                    value={branchInfo.branchName}
                                    onChange={handleChange}
                                    className={`${isFormFieldInvalid({
                                      name: `branches[${index}].branchName`,
                                      touched,
                                      errors,
                                    })}`}
                                  />
                                  <Button
                                    type="button"
                                    text
                                    severity="danger"
                                    className="icon-only-delete-button"
                                    onClick={e =>
                                      deleteButtonOnClicked(e, {
                                        arrayHelpers,
                                        item: branchInfo,
                                        index,
                                      })
                                    }
                                  >
                                    <span className="delete-icon">
                                      <img src="assets/img/trash-icon.svg" alt="Delete" />
                                    </span>
                                  </Button>
                                </div>
                                {getFormErrorMessage({
                                  name: `branches[${index}].branchName`,
                                  touched,
                                  errors,
                                })}
                              </div>
                              <div className="input-text-field-container meraki-field">
                                <FieldArray
                                  name={`branches[${index}].merakiArubaList`}
                                  render={merakiArubaListHelpers => {
                                    return (
                                      <>
                                        {branchInfo.merakiArubaList.map(
                                          (merakiArubaInfo, merakiArubaIndex) =>
                                            renderMerakiArubaItem({
                                              index,
                                              merakiArubaIndex,
                                              merakiArubaInfo,
                                              setFieldValue,
                                              touched,
                                              errors,
                                              merakiArubaListHelpers,
                                              branchInfo,
                                            })
                                        )}
                                        <div className="add-meraki-button-container">
                                          <Button
                                            severity="secondary"
                                            type="button"
                                            label="追加"
                                            className="add-new-button has-shadow"
                                            onClick={() =>
                                              addNewMerakiAruba({
                                                arrayHelpers:
                                                  merakiArubaListHelpers,
                                              })
                                            }
                                          />
                                        </div>
                                      </>
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      );
    };

    const cloneBranchList = cloneDeep(branchMerakiArubaList);

    return (
      <>
        {isLoading || isUpdating ? (
          <LoadingSpinner
            loadingText={isUpdating ? COMMON_TEXT.UPDATING_DATA : null}
          />
        ) : (
          <Formik
            key={this.state.formKey}
            initialValues={{
              branches: cloneBranchList
                .sort((a, b) => a.branchOrder - b.branchOrder)
                .map(branchItem => ({
                  tenantId: branchItem.tenantId,
                  branchId: branchItem.branchId,
                  branchName: branchItem.branchName,
                  branchOrder: branchItem.branchOrder,
                  merakiArubaList: branchItem.merakiArubaList,
                })),
            }}
            validationSchema={formSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, handleChange, touched, errors, setFieldValue }) => (
              <Form id="location-setting-form">
                <FieldArray
                  name="branches"
                  render={arrayHelpers => (
                    <>
                      <div className="location-setting-form-container" ref={this.locationSettingFormContainerRef}>
                        <div className="main-row-container is-header">
                          <div className="index-field">
                          </div>
                          <div className="name-field">
                            {COMMON_TEXT.BRANCH_SETTING_HEADER2}
                          </div>
                          <div className="meraki-field">
                            {COMMON_TEXT.BRANCH_SETTING_HEADER3}
                          </div>
                          <div className="action-field"></div>
                        </div>
                        {renderMainContent({
                          values,
                          arrayHelpers,
                          handleChange,
                          setFieldValue,
                          touched,
                          errors,
                        })}
                      </div>
                      <div className="main-row-container is-submit-button-container">
                        <Button
                          severity="success"
                          type="button"
                          label="追加"
                          className="add-new-button has-shadow"
                          onClick={() =>
                            addNewBranch({
                              arrayHelpers,
                              branches: values.branches,
                            })
                          }
                        />
                      </div>
                    </>
                  )}
                />
              </Form>
            )}
          </Formik>
        )}
      </>
    );
  }

  render() {
    const { tenant } = this.state;
    return (
      <>
        <Toast ref={this.toastRef} position="top-center" />
        <ConfirmDialog />
        <div className="config-container custom-config-container location-setting-container custom-setting-config-container">
          <div className="config-title-container">
            <div className="text-left">
              <div className="title-text">{COMMON_TEXT.LOCATION_SETTING}</div>
            </div>
            <div className="grid grid-nogutter align-items-center justify-content-end">
              <SaveButton
                type="submit"
                loading={this.state.isUpdating}
                form="location-setting-form"
                label="保存"
                iconSrc="assets/img/save-setting-icon.svg"
                iconAlt="Save"
              />
            </div>
          </div>
          <div className="config-content">
            <div className="setting-content">
              {tenant ? (
                this.renderSettingContent()
              ) : (
                <Message
                  severity="error"
                  text={COMMON_TEXT.TENANT_NOT_SELECTED_PLEASE_SELECT}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

LocationSetting.propTypes = {};

export default LocationSetting;
